// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n9-1";
export var messageSideRight = "_n9-2";
export var subscribeToBackInStockBubbleContainer = "_n9-0";